
import Vue from "vue"
import { Component } from "vue-property-decorator"
import CreateReminderViewModel from "@/models/reminders/createReminderViewModel"

@Component
export default class PageCreateReminderComponent extends Vue {
    languages: string[] = [];
    isLoading = false;
    vm: CreateReminderViewModel = new CreateReminderViewModel();
    get title(): string {
        return this.id ? "Редактирование напоминания" : "Добавление напоминания";
    }
    get id(): number {
        const routeId = this.$route.params.id;
        return routeId ? Number(routeId) : 0;
    }
    async created() {
        this.languages = await this.$cacheProvider.getLanguagesAsync();
        this.vm.initLanguages(this.languages);
        this.vm.id = this.id;
        if (this.id) {
            await this.fetchData();
        }
    }
    async fetchData() {
      this.isLoading = true;
      try {
        const res = await this.$api.ReminderService.getReminderAsync(this.id);
        this.vm.fromServerModel(res);
      } catch (error) {
        this.$notification.error(error);
      } finally {
        this.isLoading = false;
      }
    }
    async save() {
      const isValid = (this.$refs.validator as any).isValid();
      if (!isValid) {
        return;
      }
      if (!this.hasAtLeastOneTranslation()) {
        this.$notification.error("Заполните хотя бы один перевод полностью");
        return;
      }
      this.isLoading = true;
      try {
        if (this.id) {
          this.vm.id = this.id;
          await this.$api.ReminderService.updateAsync(this.vm.toServerModel());
          this.$notification.success("Напоминание успешно обновлено");
        } else {
          await this.$api.ReminderService.createAsync(this.vm.toCreateServerModel());
          this.$notification.success("Напоминание успешно добавлено");
        }
        this.$router.back();
      } catch (error) {
        this.$notification.error(error);
      } finally {
        this.isLoading = false;
      }
    }
    hasAtLeastOneTranslation(): boolean {
      return (this.vm.translations || []).some((item) => {
        const title = (item.title || "").trim();
        const text = (item.text || "").trim();
        return Boolean(title && text);
      });
    }
}
